import React, { useCallback, useLayoutEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import { ITEM_KINDS } from '../constants'
import { isScrolledToEnd } from '../helpers'
import DropdownColumn from './component'

const DropdownColumnContainer = ({ column, columnId, onItemClick }) => {
  const listRef = useRef(null)
  const [isFadeVisible, setIsFadeVisible] = useState(false)
  const [scrollbarWidth, setScrollbarWidth] = useState(0)

  const updateFade = useCallback(() => {
    const list = listRef.current
    if (!list) {
      setIsFadeVisible(false)
      return
    }

    setIsFadeVisible(!isScrolledToEnd(list))
    setScrollbarWidth(list.offsetWidth - list.clientWidth)
  }, [])

  useLayoutEffect(updateFade, [column.items, updateFade])

  return (
    <DropdownColumn
      column={column}
      columnId={columnId}
      isFadeVisible={isFadeVisible}
      listRef={listRef}
      onItemClick={onItemClick}
      onListScroll={updateFade}
      scrollbarWidth={scrollbarWidth}
    />
  )
}

DropdownColumnContainer.propTypes = {
  column: PropTypes.shape({
    kind: PropTypes.oneOf(Object.values(ITEM_KINDS)).isRequired,
    title: PropTypes.string,
    tier: PropTypes.number,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        route: PropTypes.string,
        isSelected: PropTypes.bool,
      }),
    ),
  }).isRequired,
  columnId: PropTypes.string.isRequired,
  onItemClick: PropTypes.func.isRequired,
}

export default DropdownColumnContainer
